import { createI18n } from 'vue-i18n';

import messages from '@/i18n';
import { DEFAULT_LANGUAGE } from '@/utils/constants/general-constants';


export type MessageLanguages = keyof typeof messages;
export type MessageSchema = (typeof messages)['en'];

declare module 'vue-i18n' {
}
/* eslint-enable @typescript-eslint/no-empty-interface */
export const i18n = createI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  legacy: false,
  globalInjection: true,
  messages,
});
